<div class="pc-nh-container" id="home"> 
    <header>
        <div class="gradient"></div>
        <div class="welcome">
            <h1 class="headline1">Bemvindo ao Kulonga E-learn</h1>
            <p> Cansado de esperar o regresso as aulas?</p>
            <p> O kulonga ajuda-te a continuar as suas 
                aulas sem se quer sair de casa</p>
        </div>
        <div class="pc-nh-btn">
            <button id="b1" [routerLink]="['/login']" >Inscrever-se</button>
            <button id="b2">Assita uma demo</button>
        </div>
        
    </header>

    <main class="main">
        
        <section class="pc-nh-1st-section">
           
           <div class="pc-nh-section-content">
            <h1>O QUE É O KULONGA</h1>
            <p>
                kulonga é uma e-learn que permita que você continue os seus estudos onde
            </p>
            <p>quer que estejes.em casa .no carro,em qualquer lugar desde que uses um </p>
            <p>smartphone ou um laptop</p>
           </div>

           <div class="pc-nh-overlaped-img">
               <img src="../../assets/img/landpage/alex_rainer-jVjlBQg-Gj8-unsplash.jpg" 
               width="500" class="img1"
               alt="img1-loading">
               <img src="../../assets/img/landpage/ali-yahya-Tn224epst1E-unsplash.jpg" 
               width="400" class="img2"
               alt="img1-loading">
           </div>
        </section>

        <div class="pc-nh-features">
           <!-- create a feature using ngFor to generate 3features  -->
           <h1>O KULONGA TEM PARA SÍ</h1>

           <div>
            <div class="feature-content">
                <img src="../../assets/svg/flask-beaker-line.png" alt="feature loading">
                <div class="subcontent">
                    <h4>Bate papo com colegas e professores</h4>
                    <p>kulonga é uma e-learn que permita que você continue os seus estudos onde </p>
                    <p>quer que estejes.em casa</p>
                    
                </div>
            </div>

            <div class="feature-content">
                <img src="../../assets/svg/resource-pool-solid-alerted.png" alt="feature loading">
                <div class="subcontent">
                    <h4>Testes online e partilha 
                        de materias</h4>
                    <p>kulonga é uma e-learn que permita que você continue os seus estudos onde </p>
                    <p>quer que estejes.em casa</p>
                    
                </div>
            </div>

            <div class="feature-content">
                <img src="../../assets/svg/display-line-alerted.png" alt="feature loading">
                <div class="subcontent">
                    <h4>Assitir aulas gravadas ou até
                        mesmo livestream</h4>
                    <p>kulonga é uma e-learn que permita que você continue os seus estudos onde </p>
                    <p>quer que estejes.em casa</p>
                    
                </div>
            </div>

        </div>
        </div>

        <div class="universities" id="university">
            <h1>UNIVERSIDADES QUE JÁ USAM O KULONGA</h1>
            <div class="grid">
                <figure class="fig1">
                    <figcaption>
                        <img src="" alt="university-img">
                        <h1>UNIVERSIDAD CATÓLICA</h1>
                        <p>
                            kulonga é uma e-learn que permita que você continue os seus estudos onde
                        </p>
                        <p>quer que estejes.em casa .no carro,em qualquer lugar desde que uses um </p>
                        <p>smartphone ou um laptop</p>
                        <button>ver perfil</button>
                    </figcaption>
                </figure>

                <figure class="fig2">
                    <figcaption>
                        <img src="" alt="university-img">
                        <h1>UNIVERSIDAD CATÓLICA</h1>
                        <p>
                            kulonga é uma e-learn que permita que você continue os seus estudos onde
                        </p>
                        <p>quer que estejes.em casa .no carro,em qualquer lugar desde que uses um </p>
                        <p>smartphone ou um laptop</p>
                        <button>ver perfil</button>
                    </figcaption>
                </figure>

                <figure class="fig3">
                    <figcaption>
                        <img src="" alt="university-img">
                        <h1>UNIVERSIDAD CATÓLICA</h1>
                        <p>
                            kulonga é uma e-learn que permita que você continue os seus estudos onde
                        </p>
                        <p>quer que estejes.em casa .no carro,em qualquer lugar desde que uses um </p>
                        <p>smartphone ou um laptop</p>
                        <button>ver perfil</button>
                    </figcaption>
                </figure>

                <figure class="fig4">
                    <figcaption>
                        <img src="" alt="university-img">
                        <h1>UNIVERSIDAD CATÓLICA</h1>
                        <p>
                            kulonga é uma e-learn que permita que você continue os seus estudos onde
                        </p>
                        <p>quer que estejes.em casa .no carro,em qualquer lugar desde que uses um </p>
                        <p>smartphone ou um laptop</p>
                        <button>ver perfil</button>
                    </figcaption>
                </figure>

                <figure class="fig5">
                    <figcaption>
                        <img src="" alt="university-img">
                        <h1>UNIVERSIDAD CATÓLICA</h1>
                        <p>
                            kulonga é uma e-learn que permita que você continue os seus estudos onde
                        </p>
                        <p>quer que estejes.em casa .no carro,em qualquer lugar desde que uses um </p>
                        <p>smartphone ou um laptop</p>
                        <button>ver perfil</button>
                    </figcaption>
                </figure> 
            </div>
        </div>
    </main>

    <footer>
<div class="flex-footer">

        <div class="first" id="solutions">
            <h5>Soluções</h5>
            <div class="uls">
                <li><a href="#">Kulonga Skills</a></li>
                <li><a href="#">Kulonga Flow</a></li>
                <li><a href="#">Gift of Kulonga</a></li>
                <li><a href="#">View Pricing</a></li>
                <li><a href="#">Contact Sales</a></li>
                
            </div>
        </div>

        <div class="first" id="platform">
            <h5>Plataformas</h5>
            <div class="uls">
                <li><a href="">Browse library</a></li>
                <li><a href="">Kulonga Tests</a></li>
                <li><a href="">Kulonga cursos</a></li>
                <li><a href="">Kulonga pro</a></li>
            </div>
        </div>

        <div class="first">
            <h5>Recursos</h5>
            <div class="uls">
                <li><a href="">Dribbble Kulong</a></li>
                <li><a href="">Streamline.io icons</a></li>
                <li><a href="">Kulonga Server CI CD</a></li>
                <li><a href="">pc-nh.js library</a></li>
                <li><a href="">pc-nh.css libray</a></li>
                <li><a href="">Authored by pc-nh.js owner</a></li>
            </div>
        </div>
</div>

<div class="follow">
    <div>
    <ul>
        <li><img src="../assets/img/kulonga-small.png"  width="30" class="logo" alt=""></li>
        <li> <h5>Copyright © 2020 Kulonga E-learn. All rights reserved
        </h5></li>
        <li> <h5>Termos de politica</h5></li>
        <li> <h5>Politica de privacidade</h5></li>
    </ul>
    </div>
</div>
    </footer>
    
</div>